export const ALLOW_PPV_TYPES = ['video', 'program', 'ebook', 'audiobook'];
